var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaniIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6531 10.5413C13.2515 11.5888 14.2198 13.5562 13.8441 15.7158C13.5008 17.6848 11.9511 19.3058 10.037 19.7168C6.87916 20.3964 4.076 17.8721 4.076 14.7495V7.07723V4.17177C4.076 1.86793 2.25095 0 0 0V14.7893H0.00161939C0.00323878 20.5058 5.05411 24.9892 10.8629 23.8107C14.2717 23.1196 17.0441 20.3268 17.7809 16.8511C19.0505 10.8645 14.6296 5.57725 9.00056 5.57725C9.00056 7.58606 9.99972 9.45731 11.6531 10.5413Z",
    fill: "url(#paint0_linear_563_4708)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_563_4708",
    x1: 369.681,
    y1: 0.000041399,
    x2: 1940.41,
    y2: 1999.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D5AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5444F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaniIcon);
export default __webpack_public_path__ + "static/media/bani-icon.89bb71b4a8b76b8562c5fc4828bda10c.svg";
export { ForwardRef as ReactComponent };